﻿[
  {
    "draftJersey": "001",
    "name": "Marc Arus",
    "age": 19,
    "foot": "right",
    "height": 186,
    "weight": 75,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/001.jpg",
    "macros": {
      "reflexes": 62,
      "handling": 70,
      "kicking": 60,
      "diving": 73
    },
    "profileYtVideoId": "qiqk5aIrlWI"
  },
  {
    "draftJersey": "002",
    "name": "Pol Lechuga",
    "age": 26,
    "foot": "right",
    "height": 171,
    "weight": 70,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/002.jpg",
    "macros": {
      "reflexes": 81,
      "handling": 84,
      "kicking": 70,
      "diving": 60
    },
    "profileYtVideoId": "2epKlapE2Z4"
  },
  {
    "draftJersey": "015",
    "name": "Xavier Sánchez",
    "age": 25,
    "foot": "right",
    "height": 184,
    "weight": 93,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/015.jpg",
    "macros": {
      "reflexes": 55,
      "handling": 60,
      "kicking": 53,
      "diving": 56
    },
    "profileYtVideoId": "hId_Q42ZEZY"
  },
  {
    "draftJersey": "030",
    "name": "Iván Fajardo",
    "age": 25,
    "foot": "right",
    "height": 194,
    "weight": 98,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/030.jpg",
    "macros": {
      "reflexes": 61,
      "handling": 60,
      "kicking": 74,
      "diving": 63
    },
    "profileYtVideoId": "A8hZsZgfNYI"
  },
  {
    "draftJersey": "045",
    "name": "Josep Corderas",
    "age": 29,
    "foot": "right",
    "height": 184,
    "weight": 79,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/045.jpg",
    "macros": {
      "reflexes": 60,
      "handling": 74,
      "kicking": 60,
      "diving": 60
    },
    "profileYtVideoId": "HOMZkPmppZI"
  },
  {
    "draftJersey": "059",
    "name": "Sergi Aguilar",
    "age": 27,
    "foot": "right",
    "height": 184,
    "weight": 82,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/059.jpg",
    "macros": {
      "reflexes": 70,
      "handling": 73,
      "kicking": 81,
      "diving": 71
    },
    "profileYtVideoId": "BUh20zVI8Qg"
  },
  {
    "draftJersey": "060",
    "name": "Marc Briones",
    "age": 24,
    "foot": "right",
    "height": 184,
    "weight": 74,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/060.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 81,
      "kicking": 80,
      "diving": 84
    },
    "profileYtVideoId": "cwPCMJy26gA"
  },
  {
    "draftJersey": "073",
    "name": "Enric Planas",
    "age": 21,
    "foot": "right",
    "height": 191,
    "weight": 84,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/073.jpg",
    "macros": {
      "reflexes": 71,
      "handling": 70,
      "kicking": 66,
      "diving": 68
    },
    "profileYtVideoId": "d-BHyqDvD2g"
  },
  {
    "draftJersey": "074",
    "name": "Raul Perez",
    "age": 19,
    "foot": "right",
    "height": 189,
    "weight": 76,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/074.jpg",
    "macros": {
      "reflexes": 80,
      "handling": 71,
      "kicking": 72,
      "diving": 66
    },
    "profileYtVideoId": "tHbSthc5XR8"
  },
  {
    "draftJersey": "089",
    "name": "Javier Morales",
    "age": 20,
    "foot": "right",
    "height": 185,
    "weight": 86,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/089.jpg",
    "macros": {
      "reflexes": 83,
      "handling": 83,
      "kicking": 76,
      "diving": 74
    },
    "profileYtVideoId": "zK3GlQWc6F4"
  },
  {
    "draftJersey": "090",
    "name": "Jorge Ibáñez",
    "age": 19,
    "foot": "right",
    "height": 183,
    "weight": 79,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/090.jpg",
    "macros": {
      "reflexes": 84,
      "handling": 83,
      "kicking": 82,
      "diving": 78
    },
    "profileYtVideoId": "1HR__Sr_8E0"
  },
  {
    "draftJersey": 104,
    "name": "Mario León",
    "age": 39,
    "foot": "right",
    "height": 182,
    "weight": 88,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/104.jpg",
    "macros": {
      "reflexes": 71,
      "handling": 73,
      "kicking": 62,
      "diving": 80
    },
    "profileYtVideoId": "btykhV7u-sI"
  },
  {
    "draftJersey": 110,
    "name": "Daniel Pérez",
    "age": 24,
    "foot": "right",
    "height": 180,
    "weight": 72,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/110.jpg",
    "macros": {
      "reflexes": 90,
      "handling": 83,
      "kicking": 84,
      "diving": 86
    },
    "profileYtVideoId": "W_e3iNv4YIs"
  },
  {
    "draftJersey": 117,
    "name": "Sergio Ródenas",
    "age": 21,
    "foot": "right",
    "height": 180,
    "weight": 70,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/117.jpg",
    "macros": {
      "reflexes": 81,
      "handling": 84,
      "kicking": 74,
      "diving": 76
    },
    "profileYtVideoId": "iTm_jiD1BWU"
  },
  {
    "draftJersey": 118,
    "name": "Jose Manuel Segovia",
    "age": 31,
    "foot": "right",
    "height": 183,
    "weight": 84,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/118.jpg",
    "macros": {
      "reflexes": 85,
      "handling": 92,
      "kicking": 86,
      "diving": 86
    },
    "profileYtVideoId": "3JfmoMkSzQ4"
  },
  {
    "draftJersey": 133,
    "name": "Adria Gutiérrez",
    "age": 18,
    "foot": "right",
    "height": 185,
    "weight": 78,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/133.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 74,
      "kicking": 75,
      "diving": 84
    },
    "profileYtVideoId": "gP9i5emjS1Q"
  },
  {
    "draftJersey": 134,
    "name": "Victor Cócera",
    "age": 29,
    "foot": "right",
    "height": 175,
    "weight": 71,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/134.jpg",
    "macros": {
      "reflexes": 83,
      "handling": 92,
      "kicking": 86,
      "diving": 87
    },
    "profileYtVideoId": "i4XBlwxM1lM"
  },
  {
    "draftJersey": 161,
    "name": "Ricardo Lopez",
    "age": 51,
    "foot": "left",
    "height": 187,
    "weight": 95,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/161.jpg",
    "macros": {
      "reflexes": 82,
      "handling": 91,
      "kicking": 86,
      "diving": 92
    },
    "profileYtVideoId": "MZ6k_dUHAb4"
  },
  {
    "draftJersey": 162,
    "name": "Ignacio Berché",
    "age": 23,
    "foot": "right",
    "height": 178,
    "weight": 70,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/162.jpg",
    "macros": {
      "reflexes": 72,
      "handling": 77,
      "kicking": 79,
      "diving": 80
    },
    "profileYtVideoId": "xcA-gwpmcow"
  },
  {
    "draftJersey": 179,
    "name": "Jaume Llaveria",
    "age": 37,
    "foot": "right",
    "height": 173,
    "weight": 68,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/179.jpg",
    "macros": {
      "reflexes": 71,
      "handling": 73,
      "kicking": 66,
      "diving": 63
    },
    "profileYtVideoId": "oGdKIU0Gm4U"
  },
  {
    "draftJersey": 194,
    "name": "Iu Morral",
    "age": 22,
    "foot": "left",
    "height": 174,
    "weight": 65,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/194.jpg",
    "macros": {
      "reflexes": 71,
      "handling": 84,
      "kicking": 79,
      "diving": 83
    },
    "profileYtVideoId": "LdJXcZZyQIQ"
  },
  {
    "draftJersey": 195,
    "name": "Alex Garcia",
    "age": 20,
    "foot": "right",
    "height": 183,
    "weight": 73,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/195.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 70,
      "kicking": 76,
      "diving": 71
    },
    "profileYtVideoId": "DJ0IssfJfiA"
  },
  {
    "draftJersey": 208,
    "name": "Pol Zapata",
    "age": 23,
    "foot": "left",
    "height": 180,
    "weight": 70,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/208.jpg",
    "macros": {
      "reflexes": 86,
      "handling": 87,
      "kicking": 84,
      "diving": 94
    },
    "profileYtVideoId": "o0vYxx3WsgI"
  },
  {
    "draftJersey": 209,
    "name": "Joan Canet",
    "age": 19,
    "foot": "right",
    "height": 185,
    "weight": 83,
    "role": "PT",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2022/12/209.jpg",
    "macros": {
      "reflexes": 84,
      "handling": 95,
      "kicking": 84,
      "diving": 85
    },
    "profileYtVideoId": "E9dvqtDRkaw"
  }
]
